import React from 'react';

interface StatusDotProps {
  isActive: boolean;
  text?: string;
}

const StatusDot: React.FC<StatusDotProps> = ({ isActive, text }) => {
  return (
    <div className='flex items-center'>
      <span
        className={`inline-block w-2 h-2 rounded-full mr-2 ${
          isActive ? 'bg-[var(--sematicSuccessColor500)]' : 'bg-[var(--textBlack56)]'
        }`}
      />
      <span className='text-sm'>{text || (isActive ? 'Đang hoạt động' : 'Ngưng hoạt động')}</span>
    </div>
  );
};
interface StatusDotCommonProps {
  dotBgColor?: string;
  label?: string;
}
const StatusDotCommon: React.FC<StatusDotCommonProps> = ({ dotBgColor, label }) => {
  return (
    <div className='flex items-center'>
      <span
        className={`inline-block w-3 h-3 rounded-full mr-2 ${dotBgColor ? dotBgColor : 'bg-[var(--textBlack56)]'}`}
      />
      <span className='text-sm'>{label || '---'}</span>
    </div>
  );
};
export { StatusDotCommon };
export default StatusDot;
